function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgSafehouse(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    id: "safehouse_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 96 96",
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    "uc-svg": "www"
  }, props), React.createElement("style", null, '.safehouse_svg__st0{enable-background:new}.safehouse_svg__st1{fill:none;stroke:#050505;stroke-width:8;stroke-miterlimit:10}.safehouse_svg__st2{fill:#0a0b0c}'), React.createElement("g", {
    className: "safehouse_svg__st0"
  }, React.createElement("defs", null, React.createElement("path", {
    id: "safehouse_svg__SVGID_1_",
    className: "safehouse_svg__st0",
    d: "M60.6 66.3V53.5l7-4v12.8z"
  })), React.createElement("clipPath", {
    id: "safehouse_svg__SVGID_2_"
  }, React.createElement("use", {
    xlinkHref: "#safehouse_svg__SVGID_1_",
    overflow: "visible"
  }))), React.createElement("path", {
    className: "safehouse_svg__st2",
    d: "M48.3 1.9L8.5 25.3V71l39.7 23.4L88 71.1V25.3L48.3 1.9zm0 9.3l27 15.9-28.7 17-27-15.9 28.7-17zM80 66.5L48.3 85.2 16.5 66.5V65l30 13.8-30-20.3V55l29.6 12.5-29.6-18.2v-3.7l29.2 13.1-29.2-19.9v-3.2l30 17.7L80 33.6v32.9z"
  }), React.createElement("path", {
    className: "safehouse_svg__st2",
    d: "M62.6 59.8v5.1l2.7-1.6v-5c1.3-1.3 2.3-3.3 2.3-5.1 0-2.2-1.6-3.1-3.5-2s-3.5 3.8-3.5 6c0 1.7.9 2.6 2 2.6z"
  }));
}

SvgSafehouse.clsName = 'icon-www__safehouse';
SvgSafehouse.remarkName = 'unknown';
export default SvgSafehouse;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/Safehouse.js
// module id = 2424
// module chunks = 17 18